import tabbedContent from './tabbed-content';
export default tabbedContent;
